<template>
    <BaseForm @submit.prevent>
        <template #fields>
            <Toggle
                :value="values.singleProject"
                :label="$t('limit-to-single-project')"
                :help-button-text="$t('limit-to-single-project-help')"
                @change="setFieldValue('singleProject', $event)"
                @blur="setFieldTouched('singleProject', true)"
            ></Toggle>
            <FieldGroup :title="$t('identifiers')">
                <TextField
                    :value="values.nameShort"
                    :label="$t('name-short')"
                    :error-messages="errors.nameShort"
                    :required="true"
                    @input="setFieldValue('nameShort', ($event.target as HTMLInputElement).value)"
                    @blur="setFieldTouched('nameShort', true)"
                />
                <TextField
                    :value="values.nameLong"
                    :label="$t('name-long')"
                    :error-messages="errors.nameLong"
                    :required="true"
                    @input="setFieldValue('nameLong', ($event.target as HTMLInputElement).value)"
                    @blur="setFieldTouched('nameLong', true)"
                />
            </FieldGroup>
        </template>
        <template #buttons>
            <Button v-if="isTouched" size="Base" variant="Danger-Light" @click="onDiscard">
                <template #icon>
                    <UndoIcon class="size-5" />
                </template>
                {{ $t('discard') }}
            </Button>
            <Button v-else size="Base" variant="Neutral-Light" @click="$router.back">
                <template #icon>
                    <CloseIcon class="size-5" />
                </template>
                {{ $t('abort') }}
            </Button>
            <Button
                size="Base"
                variant="Info-Strong"
                :disabled-explanation="saveButtonDisabledExplanation"
                type="submit"
                @click="onSave"
            >
                <template #icon>
                    <AllDoneIcon class="size-5" />
                </template>
                {{ $t('create') }}
            </Button>
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import Button from '@/components/Button/Button.vue';
import BaseForm from '@/components/Form/BaseForm.vue';
import FieldGroup from '@/components/Form/FieldGroup.vue';
import TextField from '@/components/Form/TextField.vue';
import Toggle from '@/components/Form/Toggle.vue';
import AllDoneIcon from '@/components/Icon/AllDoneIcon.vue';
import CloseIcon from '@/components/Icon/CloseIcon.vue';
import UndoIcon from '@/components/Icon/UndoIcon.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectSeriesCreate } from '@/project/composables/useProjectSeriesCreate';
import { goToProjectSeries } from '@/project/project';
import { ProjectSeriesCreateSchema } from '@/project/schemas';
import { computed } from 'vue';

const {
    values,
    errors,
    saveButtonDisabledExplanation,
    isTouched,
    setFieldTouched,
    setFieldValue,
    validate,
    onDiscard,
} = useForm(
    ProjectSeriesCreateSchema,
    computed(() => ({
        singleProject: false,
        nameShort: '',
        nameLong: '',
    })),
);

const { create } = useProjectSeriesCreate(values);

async function onSave() {
    const valid = await validate();
    if (valid) {
        const { id } = await create();
        if (id) {
            goToProjectSeries(id);
        }
    }
}
</script>
